import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import enUS from "./i18n/en-US.json";
import esES from "./i18n/es-ES.json";
import ptBR from "./i18n/pt-BR.json";

@Component({
    selector: "app-cookies-dialog",
    templateUrl: "./cookies-dialog.component.html",
    styleUrls: ["./cookies-dialog.component.scss"]
})
export class CookiesDialogComponent {
    constructor(private translate: TranslateService) {
        this.translate.setTranslation("pt-BR", ptBR, true);
        this.translate.setTranslation("en-US", enUS, true);
        this.translate.setTranslation("es-ES", esES, true);
    }
}
